import axios from "axios";
import { UrlApi } from "../../../services/apirest";

export const FilesService = {
  async downloadConstancy(employeeId, periodId) {
    const response = await axios.post(
      `${UrlApi}/vacations/${employeeId}/${periodId}/constancy`,
      {},
      { responseType: "blob" }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `constancia_${employeeId}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  },

  async downloadAnnualCsv(year, filters = {}) {
    const response = await axios.post(
      `${UrlApi}/vacations/generateOds/${year}`,
      filters,
      { responseType: "blob" }
    );

    const url = window.URL.createObjectURL(
      new Blob([response.data], {
        type: "text/csv",
      })
    );

    const link = document.createElement("a");
    link.href = url;

    link.setAttribute("download", `Resumen_${year}.csv`);

    document.body.appendChild(link);
    link.click();
    link.remove();
  },

  async downloadAnnualPdf(branchId, year) {
    const response = await axios.post(
      `${UrlApi}/vacations/generatePdf/${branchId}/${year}`,
      {},
      { responseType: "blob" }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Resumen_${branchId}_${year}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  },
};
